import { FC, useMemo } from 'react';
import SwiperCore from 'swiper';
import { A11y, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { SwiperOptions } from 'swiper/types/swiper-options';
import PlatFromCardItem from './business-hub-platform-card-item/platform-card-item';

import { useWindowSize } from '../../hook/useWindowSize';
import styles from './business-hub-platform.module.scss';

export interface PlatFormCardItemProps {
    logo: string;
    title: string;
    description: string;
    linkLearnMore: string;
}

export interface BusinessHubPlatFormProps {
    backgroundColor?: string;
    header: string;
    subHeader?: string;
    showLearnMore?: boolean;
    cards: PlatFormCardItemProps[];
}

SwiperCore.use([Autoplay, A11y]);

const options: SwiperOptions = {
    slidesPerView: 'auto',
    spaceBetween: 36,
    allowTouchMove: true,
    noSwiping: false,
    freeMode: true,
    loop: true,
    navigation: true,
    pagination: false,
    speed: 1000,

    autoplay: {
        delay: 3000,
        disableOnInteraction: false,
    },

    breakpoints: {
        992: {
            watchOverflow: true,
            spaceBetween: 20,
        },
    },
};

const BusinessHubPlatForm: FC<BusinessHubPlatFormProps> = (props) => {
    const { backgroundColor, header, subHeader, cards = [], showLearnMore } = props;

    const { width = 0 } = useWindowSize();
    const isMobile = useMemo(() => width <= 998, [width]);

    return (
        <div
            className={styles.container}
            style={{
                backgroundColor: backgroundColor,
            }}
        >
            <div className={styles.wrapperContainer}>
                <div className={styles.header} dangerouslySetInnerHTML={{ __html: header }}></div>
                {subHeader && <div className={styles.subHeader} dangerouslySetInnerHTML={{ __html: subHeader }}></div>}

                <div className={styles.wrapperCards}>
                    {!isMobile ? (
                        cards.map((card, index) => {
                            return (
                                <SwiperSlide key={index}>
                                    <PlatFromCardItem
                                        key={index}
                                        logo={card.logo}
                                        title={card.title}
                                        description={card.description}
                                        linkLearnMore={card.linkLearnMore}
                                        showLearnMore={showLearnMore}
                                    />
                                </SwiperSlide>
                            );
                        })
                    ) : (
                        <Swiper {...options}>
                            {cards.map((card, index) => {
                                return (
                                    <SwiperSlide key={index}>
                                        <PlatFromCardItem
                                            key={index}
                                            logo={card.logo}
                                            title={card.title}
                                            description={card.description}
                                            linkLearnMore={card.linkLearnMore}
                                            showLearnMore={showLearnMore}
                                        />
                                    </SwiperSlide>
                                );
                            })}
                        </Swiper>
                    )}
                </div>
            </div>
        </div>
    );
};

export default BusinessHubPlatForm;
